import { render } from "./ProjectsHighlight.vue?vue&type=template&id=11482cb0&scoped=true"
import script from "./ProjectsHighlight.vue?vue&type=script&lang=js"
export * from "./ProjectsHighlight.vue?vue&type=script&lang=js"

import "./ProjectsHighlight.vue?vue&type=style&index=0&id=11482cb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11482cb0"]])

export default __exports__